<template>
  <LKPublicationsFormdataModalContainer
    v-if="isActive"
    content-class="LKPublicationsFormdataTableEditModal"
    @close="close"
  >
    <div class="LKPublicationsFormdataTableEditModal__header">
      <div class="text-lg-bold">
        {{ disabled ? 'Просмотр записи' : 'Редактирование записи' }}
      </div>

      <IconClose
        @click.native="close"
      />
    </div>
    <div>
      <span v-text="sheetHint" />
    </div>
    <div
      v-if="displayImages.length"
      class="LKPublicationsFormdataTableEditModal__content__preview"
    >
      <div class="d-flex align-center justify-space-between mb-2">
        <p class="mb-0 font-weight-bold">
          Изображения ({{ displayImages.length }})
        </p>
        <div class="d-flex flex-column align-center">
          <v-btn
            icon
            x-small
            class="LKPublicationsFormdataTableEditModal__toggle-btn"
            @click="imagesExpanded = !imagesExpanded"
          >
            <v-icon>
              {{ imagesExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>
          </v-btn>
          <span class="LKPublicationsFormdataTableEditModal__toggle-label">
            {{ imagesExpanded ? 'Свернуть' : 'Развернуть' }}
          </span>
        </div>
      </div>
      <v-expand-transition>
        <div v-show="imagesExpanded" class="LKPublicationsFormdataTableEditModal__images-container">
          <div
            v-for="(img, i) in displayImages"
            :key="i"
            class="LKPublicationsFormdataTableEditModal__image-item"
          >
            <v-img
              :src="img"
              max-height="180"
              max-width="240"
              contain
              class="mb-2 rounded elevation-2"
            />
            <v-btn
              color="primary"
              outlined
              x-small
              :href="img"
              target="_blank"
              rel="noopener"
              class="LKPublicationsFormdataTableEditModal__open-btn"
            >
              Открыть
            </v-btn>
          </div>
        </div>
      </v-expand-transition>
    </div>
    <div class="LKPublicationsFormdataTableEditModal__content">
      <template v-for="(header, idx) in headers">
        <v-row
          :key="header.value"
          dense
          :class="{ 'LKPublicationsFormdataTableEditModal__content__odd': idx % 2 !== 0 }"
        >
          <v-col cols="12" class="d-flex align-center">
            <p class="mb-0 font-weight-bold">
              {{ headerTextProcess(header, idx, item) }}
            </p>

            <div
              class="LKPublicationsFormdataTableEditModal__content__hint"
            >
              {{ headerDescriptionProcess(header, idx, item) }}
            </div>
          </v-col>
          <v-col cols="12">
            <LKPublicationsFormdataTableInput
              :headers="headers"
              :header="header"
              :data="item"
              :index="index"
              :all_cells="all_cells"
              :disabled="disabled"
              :max-value="max(idx)"
              :vertical-line-data="verticalLineData"
              :vertical-cells-data="verticalCellsDataUnique[header.$cell.$index]"
              class="is-cell"
            />
          </v-col>
        </v-row>
      </template>
    </div>
    <div class="LKPublicationsFormdataTableEditModal__footer">
      <v-btn
        v-if="!disabled"
        depressed
        outlined
        @click="onCancel"
        v-text="'Отменить'"
      />
      <v-btn
        v-if="!disabled"
        class="LKPublicationsFormdataTableEditModal__footer--submit-btn"
        depressed
        outlined
        @click="onSubmit"
        v-text="'Сохранить'"
      />
      <v-btn
        v-if="disabled"
        depressed
        outlined
        @click="close"
        v-text="'Закрыть'"
      />
    </div>
  </LKPublicationsFormdataModalContainer>
</template>

<script>
import IconClose from '@/components/lk/icons/LKIconClose.vue'
import LKPublicationsFormdataModalContainer from './LKPublicationsFormdataModalContainer.vue'
import LKPublicationsFormdataTableInput from '../LKPublicationsFormdataTableInput.vue'


export default {
  name: 'LKPublicationsFormdataTableEditModal',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    IconClose,
    LKPublicationsFormdataModalContainer,
    LKPublicationsFormdataTableInput,
  },
  inheritAttrs: false,
  props: {
    all_cells: {
      type: Array,
      required: true,
      validator: ([prop]) => !prop || (
        prop
        && 'uuid' in prop
        && '$index' in prop
        && '$sheet' in prop
        && '$data' in prop.$sheet
      ),
    },
    headers: {
      type: Array,
      required: true,
    },
    data: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
      ),
    },
    index: {
      type: Number,
      required: true,
    },
    disabled: Boolean,
    /**
     * Данные для зависимости от других листов
     */
    verticalLineData: {
      type: Object,
      default: () => {},
    },
    /**
     * Для проверок уникальности значений
     */
    verticalCellsData: {
      type: Object,
      default: () => {},
    },
    onSave: {
      type: Function,
      required: true,
    },
    headerTextProcess: {
      type: Function,
      default: (val) => val?.text || val,
    },
    headerDescriptionProcess: {
      type: Function,
      default: (header) => header?.$cell?.description,
    },
    scheduleInformation: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    isActive: false,
    item: {},
    imagesExpanded: false,
  }),
  computed: {
    displayImages() {
      if (Array.isArray(this.item.image)) {
        return this.item.image
      }
      return []
    },
    sheetHint() {
      return this.headers[0]?.$cell.$sheet.hint
    },
    verticalCellsDataUnique() {
      const list = {}
      const { data, item, verticalCellsData } = this
      this.headers.forEach(({ $cell }) => {
        if ($cell.unique) {
          const cellList = []
          const counter = {}
          verticalCellsData[$cell.$index].forEach((value) => {
            if (!counter[value]) counter[value] = 1
            else counter[value] += 1
          })
          Object.keys(counter).forEach((value) => {
            cellList.push(value)
            if (counter[value] > 1) cellList.push(value)
          })
          // eslint-disable-next-line eqeqeq
          if (item[$cell.$index] != data[$cell.$index]) {
            cellList.push(item[$cell.$index])
          }
          list[$cell.$index] = cellList
        }
      })
      return list
    },
  },
  methods: {
    open() {
      // ждем подгрузки стилей для анимации модалки
      setTimeout(() => {
        this.item = { ...this.data }
        this.isActive = true
        // Валидируем данные сразу после открытия
        this.$nextTick(() => {
          this.$validator.validate()
        })
      }, 300)

      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    max(idx) {
      let diff = 0
      const targetIdx = idx - 1
      if (targetIdx >= 0 && typeof this.item[targetIdx] === 'string' && this.item[targetIdx].match(/^\d{2}.\d{2}.\d{4}$/)) {
        const info = this.scheduleInformation
        const date = this.item[targetIdx].split('.').reverse().join('-')
        const { limit, count } = info.find((el) => el.date === date) ?? {}
        diff = (limit ?? 0) - (count ?? -1)
      }
      return diff
    },
    close() {
      this.isActive = false
      this.resolve()
      this.resolve = null
      this.$emit('closed')
    },
    async onSubmit() {
      if (!await this.$validator.validate()) {
        const errors = this.$validator.errors?.items
        if (Array.isArray(errors) && errors.length > 0) {
          if (errors.every(({ rule }) => rule === 'required')) {
            this.$notice.warning('Не все обязательные поля заполнены', { type: 'pink' })
            return
          }
          this.$notice.warning('В форме есть ошибки', { type: 'pink' })
          return
        }
      }
      const result = await this.onSave(this.item, this.index)
      if (result === false) return
      this.close()
    },
    onCancel() {
      this.close()
    },
  },
}
</script>

<style lang="scss">
$btn-blue: $webflow-color-blue-dark;
$modal-padding: 20px;

.LKPublicationsFormdataTableEditModal {
  position: absolute;
  top: $modal-padding;
  right: $modal-padding;
  left: $modal-padding;
  z-index: 5;
  display: flex;
  flex-direction: column;
  max-height: calc(100% - #{2 * $modal-padding});
  padding: $modal-padding;
  margin: 0 auto;
  overflow: unset;
  background-color: $color-white;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

  @media (min-width: 767px) {
    max-width: calc(50% - #{2 * $modal-padding});
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 20px;

    .LKIconClose {
      cursor: pointer;
    }
  }

  &__content {
    padding: 20px 0.25rem;
    margin-right: -0.25rem;
    margin-left: -0.25rem;
    overflow-x: hidden;
    overflow-y: auto;
    color: $webflow-color-black;

    &__odd {
      background-color: $webflow-color-blue-shadow;
    }
  }

  &__content__hint {
    font-size: 12px;
    font-style: italic;
    color: $webflow-color-blue-dark;
  }

  &__content__preview {
    padding: 12px 0.25rem;
    margin-right: -0.25rem;
    margin-left: -0.25rem;
    margin-bottom: 12px;
  }

  &__images-container {
    display: flex;
    gap: 16px;
    justify-content: center;
    overflow-x: auto;
    padding: 8px 0.25rem;
    margin-right: -0.25rem;
    margin-left: -0.25rem;

    &::-webkit-scrollbar {
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: $webflow-color-blue-shadow;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: $webflow-color-blue-dark;
      border-radius: 4px;
    }
  }

  &__image-item {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 240px;
  }

  &__open-btn {
    width: 100% !important;
  }

  &__toggle-btn {
    transition: all 0.3s ease;
  }

  &__toggle-label {
    font-size: 12px;
    color: $webflow-color-blue-dark;
    margin-top: 2px;
    font-weight: normal;
  }

  &__body {
    align-items: flex-start;
  }

  &__image {
    background: $webflow-color-blue-shadow;
    border: 1px solid $webflow-color-blue-dark;
    border-radius: 4px;
    align-items: center;
    text-align: center;
    gap: 8px;
  }

  &__footer {
    padding-top: 20px;
    text-align: right;

    .v-btn:not(:last-child) {
      margin-right: 1rem;
    }

    &--submit-btn.v-btn {
      color: $btn-blue;
      border-color: $btn-blue;
    }
  }
}
</style>
